import React from 'react';
import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';

import styles from './EmptyNotes.scss';

const EmptyNotes = () => {
  const { t } = useTranslation('common');

  return (
    <div className={styles['c-empty-notes']}>
      <div className={styles['c-empty-notes__header']}>
        <h3 className={styles['c-empty-notes__header-text']}>{t('interview.notes_heading')}</h3>
      </div>

      <div className={styles['c-empty-notes__body']}>
        <Empty description={t('interview.no_notes_message')} />
      </div>
    </div>
  );
};

export default EmptyNotes;
